import { render, staticRenderFns } from "./bgimg.vue?vue&type=template&id=5546f6ae&scoped=true&"
import script from "./bgimg.vue?vue&type=script&lang=js&"
export * from "./bgimg.vue?vue&type=script&lang=js&"
import style0 from "./bgimg.vue?vue&type=style&index=0&id=5546f6ae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5546f6ae",
  null
  
)

export default component.exports